export const PRINT_LOCATIONS = {
    BAR: {
        value: 1,
        name: "Bar"
    },
    COUNTER: {
        value: 2,
        name: "Caixa",
    },
    KITCHEN: {
        value: 3,
        name: "Cozinha"
    }
}

export const CALC = {
    FIX: {
        value: 1,
        name: "Fixo"
    },
    MEASURE: {
        value: 2,
        name: "Média",
    },
    MAJOR: {
        value: 3,
        name: "Maior"
    }
}

export const PRODUCT_STATUS = {
    ACTIVE: 1,
    DEACTIVE: 2
}